import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseQuestionComponent } from '../base-question.component';

/**
 * Section question component.
 * Displays a section divider in the form.
 * Uses Angular signals inherited from BaseQuestionComponent.
 */
@Component({
  selector: 'app-section-question',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './section-question.component.html',
  styleUrl: './section-question.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionQuestionComponent extends BaseQuestionComponent {
  onLabelChange(value: string): void {
    this.updateLabel(value);
  }

  onAdditionalInfoChange(value: string): void {
    this.updateAdditionalInfo(value);
  }
}

